import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .max(20, "Password must be at most 20 characters")
      .required("Password is required"),
  });


  export const newsSchema = Yup.object().shape({
    title: Yup.string().required("Please enter a title"),
    description: Yup.string().test('not-empty', 'Description cannot be empty', (value) =>{
      return value !== null && value.trim() !== '<p></p>';
    }).required('Description is required'),
    image: Yup.mixed().required("Please upload an image file"),
  });


  export const EmailSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
  });
  
